import React, { useState, useEffect } from 'react';
import { Loader } from '../utils/loader/Loader';
import './testform.scss';

type props = {}

export const TestForm = (props: any) => {

    const [isOnline, setIsOnline] = useState(false);

    useEffect(() =>

        setIsOnline(true), [setIsOnline]
    );

    if (isOnline === false) {

        return <Loader />;
    }
    else
        return <form id="test-form" className="white-popup-block mfp-hide">
            <div className="popup_box ">
                <div className="popup_inner">
                    <div className="popup_header">
                        <h3>Login to MCWP3</h3>
                    </div>
                    <div className="custom_form">
                        <div className="row">
                            <div className="col-xl-12">
                                <input type="text" placeholder="User Name" />
                            </div>
                            <div className="col-xl-12">
                                <input type="password" placeholder="Password" />
                            </div>
                            {/* <div className="col-xl-12">
                                <textarea name="" id="" cols={30} rows={10} placeholder="Message"></textarea>
                            </div> */}
                            <div className="col-xl-12">
                                <button type="submit" className="boxed-btn3">Login</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
}